import { render, staticRenderFns } from "./messagePopup.vue?vue&type=template&id=c95f2eb8&scoped=true&"
import script from "./messagePopup.vue?vue&type=script&lang=js&"
export * from "./messagePopup.vue?vue&type=script&lang=js&"
import style0 from "./messagePopup.vue?vue&type=style&index=0&id=c95f2eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f2eb8",
  null
  
)

export default component.exports